import { IdentificationState } from './types'
import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'

export const getters: GetterTree<IdentificationState, RootState> = {}
